import React from "react";
import Group20 from "../Group20";
import Plus from "../Plus";
import PhoneCall from "../PhoneCall";
import Mail from "../Mail";
import "./IPhone11ProMax17.css";

function IPhone11ProMax17(props) {
  const {
    image22,
    line16,
    line17,
    line31,
    line301,
    rectangle30,
    rectangle38,
    rectangle39,
    untitledDesign50,
    rectangle691,
    rectangle33,
    rectangle14,
    surname,
    partyLook,
    bridalLook1,
    engagementLook,
    rectangle70,
    vector2,
    aboutSohniJuneja,
    line302,
    junejasohniGmailCom,
    phone1,
    phone2,
    rectangle90,
    bridalLook2,
    event,
    artist,
    payXxxxAmountNow,
    payFullAmountTo,
    selectDate,
    selectTime,
    advanceBooking,
    fullPayment,
    location,
    selectPaymentOption,
    contactUs,
    proceedToBook,
    bookAppointment,
    ddMmYyyy,
    select1,
    bridalLook3,
    select2,
    select3,
    vector3,
    vector4,
    vector5,
    vector6,
    line36,
    whatsapp,
    loremIpsumDolorSi,
    sohniJuneja,
    rectangle692,
    readMore,
  } = props;

  return (
    <div className="container-center-horizontal">
      <div className="iphone-11-pro-max-17 screen">
        <div className="flex-row-18">
          <img className="vector-22" src="/img/vector-9@2x.png" />
          <img className="image-22-6" src={image22} />
          <div className="line-container">
            <img className="line-16-2" src={line16} />
            <img className="line" src={line17} />
            <img className="line" src={line31} />
          </div>
        </div>
        <div className="flex-col-23">
          <div className="overlap-group2-7">
            <img className="line-30" src={line301} />
            <div className="rectangle-68"></div>
            <img className="rectangle-30-1" src={rectangle30} />
            <div className="rectangle-36"></div>
            <div className="rectangle-37"></div>
            <Group20 />
            <img className="rectangle-38" src={rectangle38} />
            <img className="rectangle-39" src={rectangle39} />
            <div className="rectangle-44 border-2px-charm"></div>
            <img className="untitled-design-50" src={untitledDesign50} />
            <div className="rectangle-45-1 border-1px-tundora"></div>
            <img className="rectangle-69" src={rectangle691} />
            <img className="rectangle-33-1" src={rectangle33} />
            <img className="rectangle-14-1" src={rectangle14} />
            <div className="surname-1 poppins-medium-black-12px">{surname}</div>
            <div className="party-look poppins-medium-black-12px">{partyLook}</div>
            <div className="bridal-look-1 poppins-medium-black-12px">{bridalLook1}</div>
            <div className="engagement-look poppins-medium-black-12px">{engagementLook}</div>
            <img className="rectangle-70" src={rectangle70} />
            <img className="vector-23" src={vector2} />
            <div className="about-sohni-juneja-1 poppins-medium-tundora-16px">{aboutSohniJuneja}</div>
            <img className="line-30-1" src={line302} />
            <div className="rectangle-89"></div>
            <div className="junejasohnigmailcom-1 valign-text-bottom roboto-normal-tundora-15px">
              {junejasohniGmailCom}
            </div>
            <div className="phone-6 valign-text-bottom roboto-normal-tundora-15px">{phone1}</div>
            <div className="phone-7 valign-text-bottom roboto-normal-tundora-15px">{phone2}</div>
            <Plus />
            <img className="rectangle-90" src={rectangle90} />
            <div className="bridal-look-2 poppins-medium-tundora-14px">{bridalLook2}</div>
            <div className="event poppins-normal-tundora-14px">{event}</div>
            <div className="artist poppins-normal-tundora-14px">{artist}</div>
            <p className="pay-xxxx-amount-now poppins-normal-tundora-10px">{payXxxxAmountNow}</p>
            <p className="pay-full-amount-to poppins-normal-tundora-10px">{payFullAmountTo}</p>
            <div className="select-date poppins-medium-tundora-14px">{selectDate}</div>
            <div className="select-time poppins-medium-tundora-14px">{selectTime}</div>
            <div className="advance-booking poppins-medium-tundora-14px">{advanceBooking}</div>
            <div className="full-payment poppins-medium-tundora-14px">{fullPayment}</div>
            <div className="location poppins-medium-tundora-14px">{location}</div>
            <div className="select-payment-option poppins-medium-tundora-14px">{selectPaymentOption}</div>
            <div className="contact-us-8 poppins-medium-tundora-14px">{contactUs}</div>
            <div className="rectangle-91 border-1px-sonic-silver"></div>
            <div className="rectangle-93 border-1px-sonic-silver"></div>
            <div className="rectangle-97 border-1px-sonic-silver"></div>
            <div className="rectangle-96"></div>
            <div className="proceed-to-book poppins-medium-white-16px">{proceedToBook}</div>
            <div className="book-appointment-1 poppins-semi-bold-tundora-16px">{bookAppointment}</div>
            <div className="ddmmyyyy poppins-medium-gray-11px">{ddMmYyyy}</div>
            <div className="rectangle-94 border-1px-sonic-silver"></div>
            <div className="rectangle-92 border-1px-sonic-silver"></div>
            <div className="ellipse-16 border-2px-tundora"></div>
            <div className="ellipse-17 border-2px-tundora"></div>
            <div className="ellipse-18"></div>
            <div className="select poppins-medium-gray-11px">{select1}</div>
            <div className="bridal-look-3">{bridalLook3}</div>
            <div className="select-1 poppins-medium-gray-11px">{select2}</div>
            <div className="select-2 poppins-medium-gray-11px">{select3}</div>
            <img className="vector-24" src={vector3} />
            <img className="vector-25" src={vector4} />
            <img className="vector-26" src={vector5} />
            <img className="vector-27" src={vector6} />
            <img className="line-36-4" src={line36} />
            <PhoneCall />
            <img className="whats-app" src={whatsapp} />
            <Mail />
          </div>
          <div className="flex-row-19">
            <div className="overlap-group3-1">
              <p className="lorem-ipsum-dolor-si-2 montserrat-normal-tundora-8px">{loremIpsumDolorSi}</p>
              <div className="sohni-juneja poppins-medium-tundora-16px">{sohniJuneja}</div>
            </div>
            <img className="rectangle-69-1" src={rectangle692} />
          </div>
          <div className="overlap-group4">
            <div className="rectangle-68-1"></div>
            <div className="read-more montserrat-semi-bold-white-8px">{readMore}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IPhone11ProMax17;
